<template>
  <div class="car-popular" v-show="cars.length > 0" @click.stop>
    <div class="car-popular__container">
      <!-- 标题栏 -->
      <div class="car-popular__title">
        <div class="car-popular__heading">Popular Cars</div>
        <a class="car-popular__view" :href="getHrefForAll()">
          <div class="car-popular__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="car-popular__icon" alt="view all icon">
        </a>
      </div>

      <!-- 卡片网格布局 -->
      <div class="car-popular__cards">
        <!-- 单个卡片 -->
        <a v-for="(car, index) in cars" :key="`car-${index}`" class="car-popular__card"
          :href="getHrefForDetail(car)">
          <!-- 车辆图片容器 -->
          <div class="car-popular__image-container">
            <img :src="car.image" class="car-popular__pic" alt="car image">
          </div>

          <!-- 卡片底部信息栏 -->
          <div class="car-popular__info-bar">
            <div class="car-popular__model">{{ car.model }}</div>
            <div class="car-popular__brand">{{ car.brand }}</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarPopular',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    })
  },
  data () {
    return {
      cars: [],
      loading: false,
      error: null
    }
  },
  mounted () {
    this.fetchPopularCars();
  },
  methods: {
    // 获取热门车辆数据
    async fetchPopularCars () {
      this.loading = true;
      this.error = null;
      try {
        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.state.domainConfig?.themeFilters || {};
        // 获取webIndex
        const webIndex = this.$store.state.domainConfig?.webIndex || 1;

        console.log(themeFilters);

        // 调用global.js中的getRecommendedPopularCars方法获取数据
        const params = {
          ...themeFilters,
          webIndex
        };
        const res = await this.$global.server.getRecommendedPopularCars(params);
        if (res.code === 200) {
          // 处理API返回的数据，确保至少有5条数据才显示
          const apiData = res.data || [];
          if (apiData.length >= 5) {
            const processedData = apiData.slice(0, 6).map(item => {
              // 从photos字段提取第一张图片作为封面
              const photos = item.photos ? item.photos.split(',') : [];
              const firstPhoto = photos.length > 0 ? photos[0] : require('@/assets/car-recommend-img.png');

              // 返回处理后的数据，映射字段名称
              return {
                id: item.id,
                model: item.name, // API中是name字段，映射为model
                brand: item.brand,
                logo: item.logoUrl || require('@/assets/car-logo.svg'), // 使用默认logo，因为API中没有提供
                year: item.year || item.marketTime?.substring(0, 4) || '-',
                category: item.purpose || '-', // 使用purpose字段作为category
                bodyType: item.type || '-', // 使用type字段作为bodyType
                price: this.formatPrice(item.leastPrice, item.mostPrice) || item.price || '-',
                image: item.cover || firstPhoto, // 使用cover字段，如果没有则使用firstPhoto
                speedValue: item.accelerationTime ? `${item.accelerationTime}s` : '-' // 添加's'后缀
              };
            });

            this.cars = processedData;
            console.log('[CarPopular] 获取热门车辆:', this.cars.length);
          } else {
            // 如果数据少于5条，则不显示
            this.cars = [];
            console.log('[CarPopular] 获取的热门车辆数据不足5条，不显示');
          }
        } else {
          throw new Error(res.message || 'Failed to get popular cars');
        }
      } catch (error) {
        console.error('[CarPopular] 获取热门车辆数据错误:', error);
        this.error = error.message || 'Failed to get popular cars';
        this.cars = [];
      } finally {
        this.loading = false;
      }
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },

    // Generate href for "View All" link
    getHrefForAll () {
      const currentChannel = this.$route.params.channel;
      const queryString = new URLSearchParams(this.$route.query).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      if (currentChannel) {
        return `/${currentChannel}/car-list${fullQueryString}`;
      }
      return `/car-list${fullQueryString}`;
    },

    // Generate href for car detail page
    getHrefForDetail (car) {
      if (!car || !car.id) {
        return 'javascript:void(0);';
      }
      const currentChannel = this.$route.params.channel;
      const formattedName = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      const queryString = new URLSearchParams(this.$route.query).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      if (currentChannel) {
        return `/${currentChannel}/cars/${formattedName}/${car.id}${fullQueryString}`;
      }
      return `/cars/${formattedName}/${car.id}${fullQueryString}`;
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-popular {
	padding: rem(60) 0;
	background: #ffffff;

	&__container {
		padding: 0 rem(120);
		width: 100%;
	}

	&__title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(20);
	}

	&__heading {
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 700;
		color: #141414;
	}

	&__view {
		display: flex;
		align-items: center;
		gap: rem(12);
		cursor: pointer;
	}

	&__view-all {
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 600;
		color: var(--theme-color);
	}

	&__icon {
		width: rem(16);
		height: rem(16);
	}

	&__cards {
		display: flex;
		flex-wrap: wrap;
		gap: rem(20);
		width: 100%;
	}

	&__card {
		flex: 0 0 calc((100% - rem(40)) / 3); /* 使每个子元素占1/3的宽度 */
		background: #ffffff;
		border-radius: rem(24);
		border: 1px solid #f2f2f2;
		overflow: hidden;
		cursor: pointer;
		transition: transform 0.3s ease;
		flex-grow: 0;
		flex-shrink: 0;

		&:hover {
			transform: translateY(-4px);
		}
	}

	&__image-container {
		width: 100%;
		height: rem(258);
	}

	&__pic {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(16) rem(16) 0 0;
		aspect-ratio: 386/258;
	}

	&__info-bar {
		background: #141414;
		padding: rem(12) rem(20);
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 0 0 rem(16) rem(16);
	}

	&__model {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 600;
		color: #ffffff;
	}

	&__brand {
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		color: #ffffff;
	}
}

// 设备类型样式 - PC
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-popular {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 设备类型样式 - 移动设备
.detect_deviece_mobile {
	.car-popular {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding: rem(30) 0;

		&__container {
			padding: 0 0 0 rem(16);
		}
		&__title {
			padding-right: rem(16);
		}

		&__cards {
			flex-wrap: nowrap;
			overflow-x: auto;
			gap: rem(8);
			padding-bottom: rem(10);
			scrollbar-width: none;
			-ms-overflow-style: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		&__card {
			width: rem(343);
			min-width: rem(343);
			border-radius: rem(16);

			&:last-child {
				margin-right: 0;
			}
		}

		&__image-container {
			height: rem(180);
		}
	}
}
</style> 